module.exports = __webpack_public_path__ + "static/media/sy_jiaogeshibai.e7327761.png";